import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { spinnerWrapper } from './Spinner.styles.js';

var Spinner = function Spinner(_a) {
  var spinnerColor = _a.spinnerColor,
      borderColor = _a.borderColor,
      _b = _a.animationSpeedMs,
      animationSpeedMs = _b === void 0 ? 500 : _b,
      _c = _a.size,
      size = _c === void 0 ? 32 : _c,
      props = __rest(_a, ["spinnerColor", "borderColor", "animationSpeedMs", "size"]);

  return React.createElement(spinnerWrapper, __assign({
    spinnerColor: spinnerColor,
    animationSpeedMs: animationSpeedMs,
    borderColor: borderColor,
    size: size
  }, props));
};

export { Spinner };